import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from '../auth/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
@Component({
  selector: 'app-welcome',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {

    var deviceInfo = this.authService.getDeviceSignature();
    if (deviceInfo) {
      
    } else {
      const remememberMe = this.authService.getRememberMe();
      if (remememberMe) {
        var deviceSignature = this.deviceService.getDeviceInfo();  
        var deviceDetails =  deviceSignature.os+' '+ deviceSignature.os_version + ',' +deviceSignature.browser+' '+deviceSignature.browser_version;   
        this.authService.setDeviceSignature('Web'+ '(' + deviceDetails + ')')
      } else {
        var deviceSignature = this.deviceService.getDeviceInfo();  
        var deviceDetails =  deviceSignature.os+' '+ deviceSignature.os_version + ',' +deviceSignature.browser+' '+deviceSignature.browser_version;   
        this.authService.setDeviceSignature('Web'+ '(' + deviceDetails + ')')
      }
    }

  }

}
